import { post, upload } from './axios.js';
import { getDeviceType } from 'utils/device';

// 获取课程列表
export const getCourseList = (data, config = {}) => {
    return post(`/course/list`, data, config);
};
// 获取课程系列数据
export const getCourseSerial = (data, config = {}) => {
    return post('/course/serial', data, config);
};

// 获取 Menu 页面合并数据（优化：合并6个接口为1个）
export const getCourseMenu = (data, config = {}) => {
    return post('/course/menu', data, config);
};

// 获取课程详情
export const getCourseDetail = (data, config = {}) => {
    return post('/course/detail', data, config);
};

// 学习时间提交
export const studyTimeSubmit = (data, config = {}) => {
    return post('/study/timesubmit', data, config);
};

// 学习完成提交
export const studyDoneSubmit = (data, config = {}) => {
    return post('/study/donesubmit', data, config);
};

// 学习记录
export const getStudyRecord = (data, config = {}) => {
    return post('/study/record', data, config);
};

// 学习完成奖励
export const studyDoneReward = (data, config = {}) => {
    return post('/study/donereward', data, config);
};

// 商品兑换记录
export const storeExchangeRecord = (data, config = {}) => {
    return post('/store/exchangerecord', data, config);
};

// 奖励记录
export const getStorRewadRecord = (data, config = {}) => {
    return post('/store/rewardrecord', data, config);
};

// 商品列表
export const getStoreGoodList = (data, config = {}) => {
    return post('/store/goodslist', data, config);
}

// 商品兑换
export const StoreExchange = (data, config = {}) => {
    return post('/store/exchange', data, config);
}

// 庄园信息
export const getGardenInfo = (data, config = {}) => {
    return post('/garden/info', data, config);
}

// 庄园信息
export const getRecordAllrecord = (data, config = {}) => {
    return post('/study/allrecord', data, config);
}

// 宠物喂养
export const gardenPeFeed = (data, config = {}) => {
    return post('/garden/petfeed', data, config);
}

// 排行榜
export const getRrankingList = (data, config = {}) => {
    return post('/ranking/list', data, config);
};

// 打卡签到
export const getCheckinStatus = (data, config = {}) => {
    return post('/checkin/status', data, config);
};
export const checkinSign = (data, config = {}) => {
    return post('/checkin/sign', data, config);
};
export const checkinMakeup = (data, config = {}) => {
    return post('/checkin/makeup', data, config);
};
export const getCheckinHonors = (data, config = {}) => {
    return post('/checkin/honors', data, config);
};
export const checkinDailyPopupSeen = (data, config = {}) => {
    return post('/checkin/daily_popup_seen', data || {}, config);
};

// 育儿顾问视频（封面、地址、阅读数、点赞数由数据库维护）
export const getParentHelpList = (data, config = {}) => {
    return post('/parenthelp/list', data || {}, config);
};
export const parentHelpRead = (data, config = {}) => {
    return post('/parenthelp/read', data, config);
};
export const parentHelpLike = (data, config = {}) => {
    return post('/parenthelp/like', data, config);
};

// 每日任务
export const getDailyTaskList = (data, config = {}) => {
    return post('/dailytask/list', data || {}, config);
};
export const dailyTaskAccept = (data, config = {}) => {
    return post('/dailytask/accept', data, config);
};
export const dailyTaskClaim = (data, config = {}) => {
    return post('/dailytask/claim', data, config);
};

// 用户注册
export const userRegister = (data, config = {}) => {
    return post('/user/register', data, config);
};

// 用户登录
export const userLogin = (data, config = {}) => {
    return post('/user/login', data, config);
};

// B端：管理员登录
export const adminLogin = (data, config = {}) => {
    return post('/admin/login', data, config);
};

// B端：管理员注册
export const adminRegister = (data, config = {}) => {
    return post('/admin/register', data, config);
};

// B端：获取用户列表
export const getAdminUserList = (data, config = {}) => {
    return post('/admin/users', data, { ...config, admin: true });
};

// B端：获取管理员信息
export const getAdminInfo = (data, config = {}) => {
    return post('/admin/info', data, { ...config, admin: true });
};

// B端：获取管理员统计数据
export const getAdminStatistics = (data, config = {}) => {
    return post('/admin/statistics', data, { ...config, admin: true });
};

// B端：获取用户学习记录
export const getAdminUserRecord = (data, config = {}) => {
    return post('/admin/user/record', data, { ...config, admin: true });
};

// B端：更新用户会员到期时间
export const updateUserVIPExpire = (data, config = {}) => {
    return post('/admin/user/vip-expire', data, { ...config, admin: true });
};
export const updateUserArea = (data, config = {}) => {
    return post('/admin/user/area', data, { ...config, admin: true });
};
export const updateUserAccessAllLevels = (data, config = {}) => {
    return post('/admin/user/access-all-levels', data, { ...config, admin: true });
};

// B端：团队管理 - 获取管理员列表（仅2级管理员）
export const getAdminList = (data, config = {}) => {
    return post('/admin/admins', data, { ...config, admin: true });
};

// B端：团队管理 - 修改管理员权限（仅2级管理员，role=0/1）
export const updateAdminRole = (data, config = {}) => {
    return post('/admin/admin/role', data, { ...config, admin: true });
};

// B端：管理员登出
export const adminLogout = (data, config = {}) => {
    return post('/admin/logout', data, { ...config, admin: true });
};

// 用户登录
export const userLogout = (data, config = {}) => {
    return post('/user/logout', data, config);
};

// 用户登录
export const userResetpwd = (data, config = {}) => {
    return post('/user/resetpwd', data, config);
};

// 用户信息（每次请求自动带 device_type 以便后端更新最近一次设备）
// 进入 welcome（听力扫描）页时上报，后端标记 welcome_seen，用于未完成 s111 时继续出现 welcome
export const setWelcomeSeen = (data = {}, config = {}) => {
    return post('/user/welcome-seen', data, config);
};

export const getUserInfo = (data = {}, config = {}) => {
    const deviceType = getDeviceType();
    const body = deviceType ? { ...data, device_type: deviceType } : data;
    return post('/user/info', body, config);
};

// 用户信息保存
export const userSave = (data, config = {}) => {
    return post('/user/save', data, config);
};

// 上传用户头像
export const uploadUserAvatar = (formData, config = {}) => {
    return upload('/user/avatar/upload', formData, config);
};

// 文件上传示例
export const uploadFile = (formData, config = {}) => {
    return upload('/upload', formData, config);
};
